export function handleLegacyHashRedirect() {
  const hash = window.location.hash;

  if (!hash) return;

  if (hash.startsWith('#/')) {
    window.location.replace('/auth');
  }
}
